module.exports = __webpack_public_path__ + "static/media/PrivacyPortalTermsofUseAgreementFinal.e65462d4.pdf";